import gql from 'graphql-tag';

export const CREATE_GET_IN_TOUCH_MUTATION = gql`
  mutation CreateGetInTouch(
    $fullName: String!
    $email: String!
    $subject: String!
    $message: String!
    $acceptPrivacyPolicy: Boolean!
    $language: ENUM_GETINTOUCH_LANGUAGE!
  ) {
    createGetInTouch(
      input: {
        data: {
          fullName: $fullName
          email: $email
          subject: $subject
          message: $message
          acceptPrivacyPolicy: $acceptPrivacyPolicy
          language: $language
        }
      }
    ) {
      getInTouch {
        id
      }
    }
  }
`;
